//////////////////////////////////////////////
//! Soundtrack.js
//////////////////////////////////////////////
var audio = {
	userEnabled: false, //will be set to 'true' automatically on desktop (see audio.init();)
	isPlaying: false,
	
	settings:[{
		id : "soundtrack",
		loop: true,
		src: data.soundtrack.src,
		type: data.soundtrack.type,
		volume: 0
	}],
	
	initSM:function(){
		
		if (Detectizr.device.type !== 'mobile') {
			audio.soundtrack = new SoundManager(audio.settings);
			audio.userEnabled = true;
		}
	},
	
	//Ipad Autostart
	onIpadTab : function(){
		audio.play("soundTrack");
		document.body.removeEventListener("touchstart",audio.onIpadTab);
 	},
	
	play:function(){
		
		if (audio.userEnabled && !audio.isPlaying && page.uiLoaded ) {
			
			audio.soundtrack.fadeIn('soundtrack');
			app.cssToggleOpen('#js-audioBtn');
			
			audio.isPlaying = true;
		} 
		
	},
	
	pause:function() {
		if (audio.isPlaying) {
			app.cssToggleOpen('#js-audioBtn');
			audio.soundtrack.fadeOut('soundtrack');
			audio.isPlaying = false;
		}
		
	},
	
	uiToggle:function(){
		
		if (audio.isPlaying && page.uiLoaded) {
			audio.pause();
		} 
		
		else {
			audio.play();
		}
		
	},
	
	userToggle:function(btnClass) {
		
		if (audio.userEnabled) {
			audio.userEnabled = false;
			audio.pause();
		} 
		
		else {
			audio.userEnabled = true;
			audio.play();
		}
		
	}
	
};